"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButton = void 0;
var react_1 = require("@emotion/react");
var styled_1 = __importDefault(require("@emotion/styled"));
var react_2 = __importDefault(require("react"));
var styles_1 = require("../../../styles");
var BaseStyle = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  min-height: 56px;\n  line-height: 1.7;\n"], ["\n  ", "\n  min-height: 56px;\n  line-height: 1.7;\n"])), (0, styles_1.MixinButtonStyle)());
var smallAndUp = styles_1.BREAKPOINTS.smallAndUp, lessThanSmall = styles_1.BREAKPOINTS.lessThanSmall;
var StyledLink = styled_1.default.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  color: ", " !important;\n  background-color: ", ";\n  font-size: 16px;\n  max-width: 100%;\n  text-decoration: none;\n  display: inline-block;\n  @media (", ") {\n    padding: 16px 96px;\n  }\n  @media (", ") {\n    padding: 16px 32px;\n    width: 100%;\n  }\n"], ["\n  ", "\n  color: ", " !important;\n  background-color: ", ";\n  font-size: 16px;\n  max-width: 100%;\n  text-decoration: none;\n  display: inline-block;\n  @media (", ") {\n    padding: 16px 96px;\n  }\n  @media (", ") {\n    padding: 16px 32px;\n    width: 100%;\n  }\n"])), BaseStyle, styles_1.COLOR.font.white, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, smallAndUp, lessThanSmall);
var LinkButton = function (_a) {
    var children = _a.children, disabled = _a.disabled, buttonType = _a.buttonType, href = _a.href, target = _a.target, backgroundColor = _a.backgroundColor, className = _a.className;
    var baseProps = {
        backgroundColor: backgroundColor,
        'data-cy-button': buttonType,
        className: className,
    };
    if (disabled) {
        return (react_2.default.createElement(StyledLink, __assign({}, baseProps, { "aria-disabled": "true", tabIndex: -1 }), children));
    }
    var isPreview = href === '';
    if (isPreview) {
        return react_2.default.createElement(StyledLink, __assign({}, baseProps), children);
    }
    return (react_2.default.createElement(StyledLink, __assign({}, baseProps, { href: href, target: target, rel: target === '_blank' ? 'noopener noreferrer' : '' }), children));
};
exports.LinkButton = LinkButton;
var templateObject_1, templateObject_2;
